// ColumnSort Actions
export const SET_COLUMN_SORT = 'SET_COLUMN_SORT';
export const RESET_COLUMN_SORT = 'RESET_COLUMN_SORT';
